import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { CustomerProvider } from "@/context/CustomerContext";
import { useFreshBuild } from "@/hooks/useFreshBuild";
import { captureCampaign } from "@/lib/campaign";
import Storefront from "@/pages/Storefront";
import Admin from "@/pages/Admin";
import Privacy from "@/pages/Privacy";

function App() {
  useFreshBuild();
  useEffect(() => { captureCampaign(); }, []);
  return (
    <div className="min-h-screen bg-[#0A0B0E]">
      <CustomerProvider>
        <CartProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Storefront />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/privacy" element={<Privacy />} />
            </Routes>
          </BrowserRouter>
        </CartProvider>
        <Toaster theme="dark" position="bottom-center" richColors style={{ pointerEvents: "none" }} toastOptions={{ style: { pointerEvents: "auto" } }} />
      </CustomerProvider>
    </div>
  );
}

export default App;
